import { render } from "./HeroOfficialBusinessStatus.vue?vue&type=template&id=3eabc866&scoped=true"
import script from "./HeroOfficialBusinessStatus.vue?vue&type=script&lang=js"
export * from "./HeroOfficialBusinessStatus.vue?vue&type=script&lang=js"

import "./HeroOfficialBusinessStatus.vue?vue&type=style&index=0&id=3eabc866&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eabc866"]])

export default __exports__